<video #video [autoplay]="getAttribute('autoplay')"
       [loop]="getAttribute('loop')"
       [muted]="getAttribute('muted')"
       playsinline
       [controls]="isVideoBlock"
       poster="{{ thumbnailUrl }}"
>
  <source src="{{ source }}"/>
</video>
